<template>
  <div class="app">
    <router-view />
  </div>
</template>

<style lang="less">

</style>
